import { useState } from "react";
import { useRequest } from "../../../hooks/useRequest";
import { EditClientFormValues, ImageUploadValues } from "../types";
import useHttpResponseAlert from "../../../hooks/useHttpResponseAlert";
import routes from "../../../routes";

function useUpdateClientDetails(id: string) {
  const [isEditing, setEditing] = useState(false);

  const {
    fetch: fetchText,
    response: responseText,
    error: errorText,
    loading: loadingText,
  } = useRequest();
  const {
    fetch: fetchImage,
    error: errorImage,
    loading: loadingImage,
  } = useRequest();

  const mergedErrors = errorImage || errorText;

  const { alert, setAlert } = useHttpResponseAlert(
    mergedErrors,
    responseText,
    "Client has been successfully updated!",
  );

  const handleSubmit = async (
    form: EditClientFormValues,
    imageUploadValues?: ImageUploadValues,
  ) => {
    const imageFile = imageUploadValues?.file;
    const payload = {
      name: form["client-name"],
      pricingPlan: {
        level: form["client-pricing-plan"],
        ...{
          billingInterval:
            form["client-pricing-plan"] !== "free" &&
            form["client-billing-interval"],
        },
      },
      products: form["client-products"],
      isPrivateLedger: form["is-private-ledger"],
      address: {
        street: form["address-street"],
        city: form["address-city"],
        zipCode: form["address-zip-code"],
        country: form["country-select"]?.code,
      },
    };
    let imagePromise: Promise<unknown> = Promise.resolve(undefined);
    if (imageFile) {
      const formData = new FormData();
      formData.append("image", imageFile);
      imagePromise = fetchImage(
        "POST",
        routes.api.client.addImage({ id }),
        formData,
      );
    }

    const [imageResult, textResult] = await Promise.all([
      imagePromise,
      fetchText("PATCH", routes.api.client.individual({ id }), payload),
    ]);

    const imageOk = !imageFile || imageResult !== undefined;
    if (textResult && textResult.status === 200 && imageOk) {
      setEditing(false);
    }
  };

  return {
    isEditing,
    setEditing,
    update: handleSubmit,
    loading: loadingText || loadingImage,
    alert,
    setAlert,
  };
}

export default useUpdateClientDetails;
